// @greenlight-spec: 28-it-dashboard-ui.md
import type { HealthAlertListItem } from '@greenlight/contract';

export function healthAlertLabel(
  item: Pick<HealthAlertListItem, 'restarts' | 'window_minutes'>,
): string {
  return `Crash loop · ${item.restarts} restart${item.restarts === 1 ? '' : 's'} in ${item.window_minutes} min`;
}

export function notifiedLabel(item: Pick<HealthAlertListItem, 'notified'>): string {
  const channels = [
    item.notified.slack ? 'Slack' : null,
    item.notified.email ? 'Email' : null,
  ].filter((c) => c !== null);
  return channels.length === 0 ? 'Nobody' : channels.join(' + ');
}

/** The selected alerts as one document, oldest first, matching the other feedback downloads. */
export function renderHealthAlertsMarkdown(items: readonly HealthAlertListItem[]): string {
  const sections = [...items]
    .sort((a, b) => a.occurred_at.localeCompare(b.occurred_at))
    .map((item) =>
      [
        `## ${item.app_slug} · ${healthAlertLabel(item)}`,
        '',
        `- App: ${item.app_name} (\`${item.app_slug}\`)`,
        `- Alert: ${item.alert}`,
        `- Restarts: ${item.restarts} in ${item.window_minutes} minutes`,
        `- Occurred: ${item.occurred_at}`,
        `- Notified: ${notifiedLabel(item)}`,
      ].join('\n'),
    );
  return `# Greenlight app health alerts\n\n${sections.join('\n\n---\n\n')}\n`;
}
